<div>
  <app-main-page>
    <app-inventory-list></app-inventory-list>
  </app-main-page>
</div>
